
import DialogTemplate from '@/_components/dialog/template/template.vue'
import LogItem from './logItem.vue'
import Log from '@/views/Log/models/log'

export default {
    name: 'ActivityLogs',
    components: { DialogTemplate, LogItem },
    data() {
        return {
            logs: [] as Array<Log>,
            timeStamp: new Date().toISOString() as string | null,
            loading: false,
            isMounted: false,
        }
    },
    mounted() {
        this.isMounted = true
    },
    methods: {
        async getLogs($state: any) {
            if (this.currentProjectId) {
                let res: Array<Log> = await Log.getLog({
                    'filter[activityLogEntityId]': this.currentProjectId,
                    'filter[activityLogNumber]': ['31'],
                    ...(this.timeStamp && { 'filter[time][lt]': this.timeStamp }),
                }).catch(() => {
                    $state.complete()
                })

                this.logs.push(...res)

                if (res.length == Log.limit) {
                    let lastElement = res?.pop()
                    this.timeStamp = lastElement ? lastElement?.['time'] : null
                    $state.loaded()
                } else {
                    this.timeStamp = null
                    if (this.logs.length > 0) {
                        $state.loaded()
                    }
                    $state.complete()
                }
            }
        },
    },
}
